module.exports = __webpack_public_path__ + "img/sharespace.7881ff9c.png";